import { FC, createContext, useEffect, useState } from 'react'
import { usePersistedState } from '@cbgms/base/hooks/persisted-state/use-persisted-state'
import { SupportEnvironment } from 'core/enums/enums'

export interface IEnvironmentContext {
  environment: SupportEnvironment
  simulatedEnvironment: SupportEnvironment
  setSimulatedEnvironment: (env: SupportEnvironment) => void
}

export const EnvironmentContext = createContext<IEnvironmentContext>({
  environment: SupportEnvironment.Production,
  simulatedEnvironment: SupportEnvironment.Production,
  setSimulatedEnvironment: () => {}
})

export const EnvironmentProvider: FC = ({ children }) => {
  const [environment, setEnvironment] = useState(SupportEnvironment.Production)
  const [simulatedEnvironment, setSimulatedEnvironment] = usePersistedState<SupportEnvironment>(
    'simulatedENV',
    SupportEnvironment.Production
  )

  useEffect(() => {
    const currentUrl = window.location.href
    const isUnderDevelopment = /(develop|localhost)/i
    if (isUnderDevelopment.test(currentUrl)) {
      setEnvironment(SupportEnvironment.Develop)
    } else {
      setEnvironment(SupportEnvironment.Production)
    }
  })

  return (
    <EnvironmentContext.Provider value={{ environment, simulatedEnvironment, setSimulatedEnvironment }}>
      {children}
    </EnvironmentContext.Provider>
  )
}
